import Platform from "../../../libs/utility/Platform";

export default {
    footerContainer:{
        display: "flex",
        flexDirection: "column",
    },
    footerImage: {
        width: "100%",
    },
    footerContentDiv: {
        display: "flex",
        flexDirection: Platform.isMobileView() ? "column" : "row",
        justifyContent: "space-between",
        paddingLeft: "60px",    
        marginTop: "-45px",
        alignItems: "center",
        zIndex: 2,
        marginRight: "60px"
    },
    actionButtonsDiv: {
        display: "flex",
        flexWrap: "wrap",
        gap: "10px",
    },
    actionButtonStyle: {
       padding: '5px 15px' 
    },
    footerIcon: {
        display: 'flex', 
        alignItems: 'center', 
        gap: '20px' 
    }
}